import React, { useState } from "react";
import "./Admin.css";
import { useNavigate } from "react-router-dom";

const AdminLogin = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleLogin = (e) => {
    e.preventDefault();

    if (username === "lushdesire@321" && password === "252849") {
      localStorage.setItem("adminLogin", true);
      navigate("/admin/dashboard");
    } else {
      alert("❌ Wrong ID or Password");
    }
  };

  return (
    <div className="admin-login">
      <form onSubmit={handleLogin} className="login-box">
        <h2>Admin Login</h2>

        <input
          type="text"
          placeholder="Admin ID"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />

        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <button type="submit">Login</button>
      </form>
    </div>
  );
};

export default AdminLogin;
